import { useProductAssetsByFields } from '@tcc/shared-data-lib';
import { useMemo } from 'react';
import { olHeaders } from 'constants/api';

export const useProductAssets = (legacyUserId: number, fieldUuids: string[]) => {
  const { data, error, isLoading } = useProductAssetsByFields({
    config: {
      olHeaders,
      skip: !fieldUuids?.length,
    },
    params: {
      legacyUserId,
      fieldUuids
    },
  });

  return useMemo(() => {
    let productAssetsByField: Record<string, string[]> | undefined;

    if (data) {
      productAssetsByField = data.userSubscription.featuresByFields.reduce((assetsByField, { fieldId, features }) => {
        assetsByField[fieldId] = features;
        return assetsByField;
      }, {});
    }

    return { productAssetsByField, error, isLoading };
  }, [data, error, isLoading]);
};
